// src/contexts/AuthContext.js
// Version: 1.0.0
import { createContext } from 'react';

export const AuthContext = createContext(null);
